import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import { MessageThreadComponent } from '../../components/patient';
import messagesData from '../../mocks/messages.json';

export const MessagesPage = () => {
  // Get the first thread as an example
  const [thread] = useState(() => {
    const firstThread = messagesData[0];
    return {
      id: firstThread.id,
      messages: firstThread.messages.map(msg => ({
        id: msg.id,
        direction: msg.direction as "TO_PATIENT" | "FROM_PATIENT",
        content: msg.content,
        createdAt: msg.sentAt,
        status: "DELIVERED" as const
      }))
    };
  });

  const handleSend = async (content: string) => {
    // TODO: Connect to API
    console.log('Sending message:', content);
    await new Promise(resolve => setTimeout(resolve, 500));
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Messages
      </Typography>
      <Typography color="text.secondary" paragraph>
        Chat with your nutritionist.
      </Typography>

      <MessageThreadComponent thread={thread} onSend={handleSend} />
    </Box>
  );
};
